import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import FlareRoundedIcon from '@mui/icons-material/FlareRounded';
import { useCallback } from 'react';
import { createGetNewestPlayersListOutbound } from '../api/outbound/commonOutbounds';
import { ExpandableSection } from '../components/expandableSection';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { DrawerButton } from './drawerButton';
import { ExpandableSectionPaddedDrawerContainer } from './drawerControl';
import { FindPlayerDrawerButton } from './findPlayerDrawerButton';
export const PlayersExpandableDrawerSection = ({ closeDrawer }) => {
    const socketSend = useSocketSend();
    const onClickNewestPlayers = useCallback(() => {
        closeDrawer();
        socketSend(createGetNewestPlayersListOutbound());
    }, [closeDrawer, socketSend]);
    return (_jsx(ExpandableSection, { expandableSectionType: 'drawer-players', colorType: 'drawer', children: _jsxs(ExpandableSectionPaddedDrawerContainer, { children: [_jsx(FindPlayerDrawerButton, { closeDrawer: closeDrawer }), _jsx(DrawerButton, { label: 'Newest Players', onClick: onClickNewestPlayers, startIcon: _jsx(FlareRoundedIcon, {}) })] }) }));
};
